export default {
  data() {
    return {
      catalog: [],
    };
  },
  methods: {
    async fetchCatalog() {
      try {
        this.catalog = await this.$apiService.getCatalogAll(this.requestData);
      } catch (e) {
        this.catalog = null;
        throw e
      }
    }
  },
  mounted() {
    this.fetchCatalog();
  }
};
